import { createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";

import { FormNames } from "../../../../resources/constants";

import { ICodeResp, IFetchCodeArgs, IFetchPassArgs } from "./types";
import { axiosInstance } from "@/resources/requestInfo";
import { changePassRoutes } from "./routes";
import { hashTokenHelper } from "@/utils/hashToken";
import { getSendCodeErrorMessage } from "@/utils/sendCodeError";

export const fetchSendPhone = createAsyncThunk<string, { phone: string }>(
  "changePass/fetchSendPhone",
  async (data, { rejectWithValue }) => {
    try {
      const hashToken = await hashTokenHelper();

      await axiosInstance.post(changePassRoutes.FORGOT_PASS, data, {
        headers: {
          "Authorization": `Bearer ${hashToken}`,
        },
      });

      return FormNames.MESSAGE;
    } catch (error: any) {
      const serverMessage = error.response?.data?.message;
      if (typeof serverMessage === "string" && serverMessage.includes("is not registered")) {
        return rejectWithValue("Пользователь с таким номером не зарегистрирован");
      }
      return rejectWithValue(getSendCodeErrorMessage(serverMessage));
    }
  }
);

export const fetchSendCode = createAsyncThunk<ICodeResp, IFetchCodeArgs>(
  "changePass/fetchSendCode",
  async (data, { rejectWithValue }) => {
    try {
      const response = await axiosInstance.post(changePassRoutes.CONFIRM_FORGOT_PASS, data);

      return response.data;
    } catch (error: any) {
      return rejectWithValue(error.response.data.message || "Ошибка отправки кода");
    }
  }
);

export const fetchSendNewPassword = createAsyncThunk<string, IFetchPassArgs>(
  "changePass/fetchSendNewPassword",
  async (data, { rejectWithValue }) => {
    try {
      const response = await axiosInstance.post(changePassRoutes.SET_NEW_PASS, data);

      return response.data;
    } catch (error: any) {
      return rejectWithValue(error.response.data.message || "Ошибка отправки нового пароля");
    }
  }
);
